const formatNumber = number => number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1&nbsp;')
const bySuffix = suffix => value => `${formatNumber(Math.round(isNaN(value) ? 0 : value))}&nbsp;${suffix}`

export const formatGrams = bySuffix('g')
export const formatKcal = bySuffix('kcal')
export const formatPercent = bySuffix('%')
